import React, {useState} from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, RequiredValidator, Select } from '../../Components/Form';
import { useNewWindow } from '../../Services/helpers';
import Button from '../../Components/Button/Button';
import ButtonRow from '../../Components/Button/ButtonRow';
import API from '../../Services/API';

const ExportInvoices = ({isOpen, setIsOpen}) => {
    const [downloadUrl, setDownloadUrl] = useState(null);

    return <Modal title="Export Invoices" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {downloadUrl ? <Download {...{downloadUrl, setDownloadUrl, setIsOpen}} /> : <ExportForm setDownloadUrl={setDownloadUrl} />}
    </Modal>
}

const Download = ({downloadUrl, setDownloadUrl, setIsOpen}) => {
    const newWindow = useNewWindow();

    return <ButtonRow layout="center">
        <Button theme="primary"
            className="mx-auto"
            icon="CloudArrowDown"
            label="Download"
            onClick={() => {
                newWindow(downloadUrl);
                setDownloadUrl(null);
                setIsOpen(false);
            }}
        />
    </ButtonRow>
}

const ExportForm = ({setDownloadUrl}) => {
    const handleSubmit = (data) => {
        return API.get('/customers/exportInvoices', data).then(res => {
            setDownloadUrl(res.downloadUrl);
        });
    }
    return <Form onSubmit={handleSubmit}>
        <Select name="dateRange"
            label="Date range"
            validators={[RequiredValidator]}
            options={[
                { value: '', label: 'Select a date range' },
                { value: 'allTime', label: 'All Time' },
                { value: 'lastYear', label: 'Last Year' },
                { value: 'thisYear', label: 'This Year' },
                { value: 'lastThreeMonths', label: 'Last Three Months' },
                { value: 'thisMonth', label: 'This Month' },
                { value: 'lastMonth', label: 'Last Month' },
                { value: 'thisWeek', label: 'This Week' },
                { value: 'lastWeek', label: 'Last Week' },
            ]}
        />
        <Select name="status"
            label="Status"
            options={[
                { value: '', label: 'All statuses' },
                { value: 'Outstanding', label: 'Outstanding' },
                { value: 'Overdue', label: 'Overdue' },
                { value: 'Paid', label: 'Paid' },
                { value: 'Deleted', label: 'Deleted' },
            ]}
        />
        <Actions submit={{label: 'Export'}} cancel={{label: 'Cancel'}} />
    </Form>
}

export default ExportInvoices;
